import { render, staticRenderFns } from "./ServiceRequest.vue?vue&type=template&id=1c471df5"
import script from "./ServiceRequest.vue?vue&type=script&lang=js"
export * from "./ServiceRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports